import { useState } from "react";
import days from "../../data/days";

function OpeningTimesForm() {
    const [openingTimes, setOpeningTimes] = useState([]);
    const exampleStructure = [
        {
            day: "mandag",
            startTime: "13:30",
            endTime: "16:30"
        },
        {
            day: "tirsdag",
            startTime: "15:10",
            endTime: "17:10"
        },
        {
            day: "fredag",
            startTime: "18:00",
            endTime: "20:00"
        }
    ];
    setOpeningTimes(exampleStructure);

    const [day, setDay] = useState("none");
    const [startTime, setStartTime] = useState("none");
    const [endTime, setEndTime] = useState("none");

    return (
        <div>
            <div id="opening-time-add-form">
                <h3><b>Velg dag</b></h3>
                <select value={day} onChange={(e) => {setDay(e.target.value)}}>
                    <option value="none" disabled hidden>Velg dag</option>
                    {days.map((dayElem, i) => (
                        <option key={i} value={dayElem.value}>{dayElem.text}</option>
                    ))}
                </select>
                <p><b>Start tid</b></p>
                <input value={startTime} onChange={(e) => {setStartTime(e.target.value);}} type="time" />
                <p><b>Slutt tid</b></p>
                <input value={endTime} onChange={(e) => {setEndTime(e.target.value)}} type="time" />
                <button>Legg til åpningstid</button>
            </div>
            <div>
                {openingTimes.map((openingSession, i) => (
                    <OpeningTimesForm info={openingSession} key={i} />
                ))}
            </div>
        </div>
    );
};

export default OpeningTimesForm;